(function() {
    'use strict';

    angular.module('app.parametros', []);
})();
